export default "__VITE_ASSET__cz6Brfl5__"